import { ratingConstants } from "./constants/ratingConstant";

const ratingGetSetting = () => {
	return {
		type: ratingConstants.RatingSettingGetRequest,
		input: {}
	};
};

const ratingUpdateSetting = (data: any) => {
	return {
		type: ratingConstants.RatingSettingUpdateRequest,
		input: data
	};
};

const ratingGetDashboard = (data: any) => {
	return {
		type: ratingConstants.RatingDashboardRequest,
		input: data
	};
};

const ratingGetAppVersions = () => {
	return {
		type: ratingConstants.RatingAppVersionsRequest,
		input: {}
	};
};

const ratingDelete = (userRatingId: any) => {
	return {
		type: ratingConstants.RatingDeleteRequest,
		input: userRatingId
	};
};

export const ratingAction = {
	ratingGetSetting,
	ratingUpdateSetting,
	ratingGetDashboard,
	ratingGetAppVersions,
	ratingDelete
};